export enum AnalyticsEventCategory {
  STAR_GAME = 'Star Game',
  SET = 'Set',
  CORRECTIVE_FEEDBACK = 'Corrective Feedback',
}
